import { ComponentType, type IConfig } from '../../types';
import { config as SimpleTriggerActionButtonConfig } from '../simple-trigger-action-button/config';
import { config as TriggerActionButtonConfig } from '../trigger-action-button/config';
import { ComponentConfigType } from '../../utils/data-parser';
import { BASIC_VALUE_TOOLTIP } from '../../utils';

const actionFormGroup = TriggerActionButtonConfig.configGroups.find(
  group => group.title === 'Action form'
)!;

export const config: IConfig = {
  component: ComponentType.FormImportInstance,
  configGroups: [
    ...SimpleTriggerActionButtonConfig.configGroups,
    {
      title: 'Import',
      items: [
        {
          name: 'transformer',
          label: 'Source Instance ID',
          valueComponent: {
            type: 'Input',
            placeholder: 'e.g. form.source.id',
          },
          configTypes: [ComponentConfigType.Value],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value:
                'JMESPath over the modal values (<code>form</code>) returning the id of the instance to import from.',
            },
          ],
        },
        {
          name: 'keepFields',
          label: 'Keep Fields',
          valueComponent: {
            type: 'Select',
            mode: 'tags',
            placeholder: 'e.g. id, status, name',
          },
          configTypes: [ComponentConfigType.Value],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value:
                'Top-level fields that keep this instance’s values; type a field name and press Enter. Everything else is replaced by the imported instance.',
            },
          ],
        },
        {
          name: 'successMessage',
          label: 'Success Message',
          valueComponent: { type: 'Input' },
          configTypes: [ComponentConfigType.Value],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
          ],
        },
      ],
    },
    {
      ...actionFormGroup,
      items: (actionFormGroup.items || []).filter(
        item => item.name !== 'actionForm.show'
      ),
    },
  ],
};
